import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, FeatureFlag, RouteName, TextKey } from '@mews-commander/enums';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { RoutingRulesListView } from '@mews-commander/modules/src/modules/routingRulesNew';
import { OptimusProvider } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/RoutingRule/Index/')({
    loader: ({ context: { localizeText, featureFlagService } }) => {
        const isNewRoutingRulesOnAddEnabled = featureFlagService.hasFlag(FeatureFlag.newRoutingRulesOnAddEnabled);
        if (isNewRoutingRulesOnAddEnabled) {
            return {
                title: () => localizeText({ textKey: TextKey.BillingAutomationPlural }),
            };
        }
    },
    component: Component,
    staticData: {
        title: TextKey.RoutingRulePlural,
        routeName: RouteName.RoutingRuleIndex,
        owner: MewsTeam.Billing,
        type: RouteType.Backend,
        guideLink: createGuideLink(ArticlePath.RouteProductsCompanyBills),
    },
});

function Component() {
    const newRoutingRulesOnAddEnabled = useFeatureFlag(FeatureFlag.newRoutingRulesOnAddEnabled);
    const { pathname, search } = Route.useMatch();
    const guideLink = createGuideLink(
        newRoutingRulesOnAddEnabled ? ArticlePath.HowToCreateBillingAutomation : ArticlePath.RouteProductsCompanyBills
    );

    return newRoutingRulesOnAddEnabled ? (
        <OptimusProvider density="spacious">
            <RoutingRulesListView guideLink={guideLink} />
        </OptimusProvider>
    ) : (
        <BackendPage url={getBackendPageUrl({ pathname, search })} />
    );
}
